function cleanText(value) {
  const text = String(value || '').trim();
  return text || '';
}

export function formatSessionDateLabel(value) {
  if (!value) {
    return '';
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }

  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfValueDay = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  const diffDays = Math.round((startOfToday - startOfValueDay) / 86400000);

  if (diffDays <= 0) {
    return 'Today';
  }
  if (diffDays === 1) {
    return 'Yesterday';
  }
  return parsed.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  });
}

export function getRecentSessionTitle(session) {
  return (
    cleanText(session?.focus_label)
    || cleanText(session?.label)
    || cleanText(session?.session_label)
    || cleanText(session?.topic_label)
    || 'Current practice'
  );
}

export function getRecentSessionSummary(session) {
  const contextLabel = cleanText(session?.context_label)
    || (session?.mode === 'EXAM' ? 'Exam' : 'Guided practice');
  const dateLabel = formatSessionDateLabel(session?.started_at || session?.ended_at);
  const outcomeLabel = cleanText(session?.outcome_label);
  return [contextLabel, dateLabel, outcomeLabel].filter(Boolean).join(' · ');
}
